export const LOOKUP_USER_SECTION_FORM_IDS: Record<string, number | null> = {
  'Name History': 3564,
  'Identity and Contact Information': 3564,
  'Veteran Status': 3564,
  'Nevada Praxis Testing': 3488,
  'Other Testing': 3488,
  'History Disclosure': 3534,
  'activities_documents': null,
  'Academic Background':3488,
  'District / Charter Employment':3738,
  'Verifiable Teaching Experience':3522,
  'Verifiable Business and Industry Work Experience':3522,
  'Additional Professional Development':3738,
  'Out of State or Country Licensure':3563,
};
